import { PDFDocument } from "pdf-lib";

export function readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

export async function mergePDFsAndCreateBase64(
  pdfBuffers: ArrayBuffer[]
): Promise<string> {
  const mergedPdf = await PDFDocument.create();

  for (const pdfBuffer of pdfBuffers) {
    const pdfDoc = await PDFDocument.load(pdfBuffer);

    const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
    pages.forEach(page => {
      mergedPdf.addPage(page);
    });
  }

  const mergedPdfBytes = await mergedPdf.save();
  const base64String = Buffer.from(mergedPdfBytes).toString("base64");

  return base64String;
}

export async function pdfToBuffer(files: File[]) {
  const pdfBuffers: ArrayBuffer[] = [];
  for (const file of files) {
    if (file) {
      const buffer = await readFileAsArrayBuffer(file);
      pdfBuffers.push(buffer);
    }
  }
  return pdfBuffers;
}
